/** Application policy; canvas motion is subordinate but independently selectable. */
export type StreamLainMotionDomain = 'app' | 'canvas';
let appEnabled = true;
let canvasEnabled = true;
const listeners = new Set<() => void>();

export function setStreamLainMotionPolicy(app: boolean, canvas: boolean): void {
  if (appEnabled === app && canvasEnabled === canvas) return;
  appEnabled = app;
  canvasEnabled = canvas;
  for (const listener of [...listeners]) listener();
}

export function isStreamLainMotionEnabled(
  domain: StreamLainMotionDomain = 'app'
): boolean {
  return appEnabled && (domain === 'app' || canvasEnabled);
}

export function subscribeStreamLainMotionPolicy(
  listener: () => void
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
